export const formatDateForProduct = dateString => {
  if (dateString.length !== 8) {
    throw new Error('Date string must be in YYYYMMDD format');
  }

  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);

  return `${year}-${month}-${day}`;
};
